import { Injectable } from '@angular/core';
import { BaseService } from '../../core/base.service';
import type { PrizeEscalation } from '../utils/redeem-escalation';

/**
 * 奖品实体
 */
export interface Prize {
  /** 主键ID */
  id: number;
  /** 奖品名称 */
  name: string;
  /** 奖品描述 */
  description?: string;
  /** 奖品图片URL */
  imageUrl?: string;
  /** 所需积分（= 基础价 / 首件价） */
  pointsRequired: number;
  /** 兑换累加配置；null/缺省 = 恒价（默认关、老数据不变），见 redeem-escalation.ts */
  escalation?: PrizeEscalation | null;
  /** 库存数量 */
  stock: number;
  /** 状态: 0=下架, 1=上架 */
  status: number;
  /**
   * 归属教师（后端 prize 表列名 user_id）。⚠️ 老代码曾误写 teacherId，后端并无 teacher_id 列、
   * 会被忽略；add/edit 载荷务必显式带 userId，否则 PUT 全量写会把 user_id 覆成 0，
   * 使编辑后的奖品掉出列表的 userId 过滤。
   */
  userId?: number;
  /** 教师ID（历史遗留名，实为归属教师；后端忽略，仅部分查询用） */
  teacherId?: number;
  /** 学期ID */
  semesterId?: number;
  /** 创建时间 */
  addTime?: string;
  /** 更新时间 */
  updateTime?: string;
}

@Injectable({ providedIn: 'root' })
export class PrizeService extends BaseService<Prize> {
  constructor() {
    super('prize');
  }
}
